import { makeStyles } from '@material-ui/core'

import { Card } from 'app/ui'

import { joinStyles, palette, various } from 'app/utils/theme'

const useStyles = makeStyles(() => ({
    root: {
        position: 'relative',
        alignItems: 'start',
        width: '100%',
        maxWidth: '400px',
        margin: '30px',
    },

    icon: {
        position: 'absolute',
        transform: `translateY(-50px)`,
        display: 'flex',
        alignItems: 'center',
        padding: '15px 30px',
        color: 'white',
        fontSize: '2rem',
        backgroundColor: palette.primary.main,
        borderRadius: various.borderRadius,
        boxShadow: various.boxShadow.component,
    },

    text: {
        margin: 'auto',
        marginTop: '30px',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        textAlign: 'center',
    },
}))

export type CardInformationProperties = {
    className?: string
    icon: JSX.Element
    iconStyle?: string
    text: string
}

export const CardInformation = ({
    className,
    icon,
    iconStyle,
    text,
}: Readonly<CardInformationProperties>): JSX.Element => {
    const classes = useStyles()

    return (
        <Card className={joinStyles(classes.root, className)}>
            <div className={joinStyles(classes.icon, iconStyle)}>{icon}</div>

            <div className={classes.text}>{text}</div>
        </Card>
    )
}
